import { render, staticRenderFns } from "./ScreenConfigureObject.vue?vue&type=template&id=2a70b9e8&scoped=true&"
import script from "./ScreenConfigureObject.vue?vue&type=script&lang=js&"
export * from "./ScreenConfigureObject.vue?vue&type=script&lang=js&"
import style0 from "./ScreenConfigureObject.vue?vue&type=style&index=0&id=2a70b9e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a70b9e8",
  null
  
)

export default component.exports